import { BaseChat } from './BaseChat';
import { MEPSDKType } from './types';

export class AnonymousChat extends BaseChat {
  constructor(mepsdk: MEPSDKType, domain: string, containerId: string) {
    super(mepsdk, domain, containerId);
    super.setup();
  }

  // The channel Id is numeric for anonymous but is string in live.
  launch(channelId: number): void {
    const acdoption = { channelId: channelId };

    try {
      const acdWindow: any = this.mepsdk.createAnonymousLiveChat(
        this.containerId,
        acdoption,
      );
      acdWindow.anonymousBoardInfoCB(function () {
        console.log('Launched anonymous live chat');
      });
    } catch (err) {
      console.log(err);
    }
  }
}
